function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.0586 12.4976L15.0529 13.0715L14.0586 12.4976Z",
  fill: "#627AFF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.4034 10.2334C5.4034 7.68288 7.47292 5.61336 10.0234 5.61336C10.0598 5.61336 10.0962 5.61336 10.1326 5.6174V2.20996C10.0962 2.20996 10.0598 2.20996 10.0234 2.20996C5.59337 2.20996 2 5.80333 2 10.2334C2 11.7168 2.40016 13.1033 3.10348 14.2916L6.05416 12.5899C5.64188 11.9028 5.4034 11.0944 5.4034 10.2334Z",
  fill: "#627AFF"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.7511 15.8518L13.3461 13.4468C12.5296 14.2916 11.3938 14.8251 10.1367 14.8534V18.2568C10.7915 18.2487 11.4261 18.1598 12.0324 18.0062C12.1618 17.9739 12.2871 17.9375 12.4124 17.8971C13.6937 17.5009 14.8376 16.7895 15.7511 15.8518Z",
  fill: "#D5FC39"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.0256 14.8544C8.336 14.8544 6.85662 13.9449 6.05225 12.5908L3.10156 14.2925C4.00294 15.8285 5.40552 17.0411 7.08297 17.7C7.38612 17.8212 7.7014 17.9223 8.02072 18.0031C8.66341 18.1688 9.33438 18.2537 10.0256 18.2537C10.062 18.2537 10.0983 18.2537 10.1347 18.2537V14.8463C10.0983 14.8544 10.062 14.8544 10.0256 14.8544Z",
  fill: "#F941C5"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.7489 15.8524C16.2339 15.3593 16.6543 14.8056 16.9979 14.1993L15.0415 13.0715L14.0472 12.4976C13.8532 12.8452 13.6147 13.1605 13.3398 13.4474L15.7489 15.8524Z",
  fill: "#20E28F"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.4927 4.59521L10.5477 8.92424L8.78535 7.26296L6.57031 9.61542L10.7255 13.5241L16.8816 6.77387L14.4927 4.59521Z",
  fill: "#627AFF"
});

var SvgTada = function SvgTada(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTada, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tada.81965e09.svg";
export { ForwardRef as ReactComponent };